export const SERVER_URL = "https://school-management-system-server.vercel.app";